<script>
import Layout from "@/layouts/main";


export default {
  name: "lifeIndex",
  data() {
   return {

   }
  },
  components: {
 
    Layout,
  
  },
  computed: {
    imgUrl(){
        var language = localStorage.getItem('language')
        var model = localStorage.getItem('deviceProfileName')
      return language == 'en'?require(model.includes('2BE1')?'./2BE1E.svg':'./TC11EC.svg'):require(model.includes('2BE1')?'./2BE1C.svg':'./TC11EE.svg')
    }
  },
  mounted() {
  },

  activated() {
  },
  methods: {
  
  },
 
};
</script>

<template>
  <Layout>
      <img style="height:100%;width:100%" :src="imgUrl" alt="">

  </Layout>
</template>
